import React from "react";
import { Link } from "react-router-dom";

const ClinicalAnnotations = () => {
  return (
    <section
      className="w-full px-6 py-12 md:px-16 md:py-16 flex flex-col md:flex-row items-center justify-between gap-8"
      style={{
        background: "linear-gradient(100.74deg, #183076 0%, #000F3D 100%)",
      }}
    >
      {/* Text Content */}
      <div className=" text-center w-full">
        <h2 className="text-white text-[24px] max-w-[1080px] m-auto md:text-[30px] lg:text-[40px] 2xl:text-[60px] font-bold mb-4 tracking-tight">
          Comprehensive Clinical Annotations
        </h2>
        <p className="text-gray-200 text-[18px] md:text-[24px] max-w-[802px] m-auto font-light leading-relaxed">
          Each specimen is supported by relevant clinical and demographic data,
          enabling deeper insights and more reliable research outcomes.
        </p>
      </div>

      {/* Button */}
      {/* <div className="flex-shrink-0">
        <Link
          to="/rfq"
          className="px-8 py-3 border border-white/40 rounded-full text-white font-semibold 
                     hover:bg-white/10 transition-colors duration-300 whitespace-nowrap text-[18px] 2xl:text-[24px]"
        >
          Download Data Scheme
        </Link>
      </div> */}
    </section>
  );
};

export default ClinicalAnnotations;
